import Axios from 'axios'
import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {CoordinateSystem} from '../../core/enums/CoordinateSystem'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {Feature} from '../../core/models'

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  dataCS: CoordinateSystem
  afterSuccess: boolean
  error: string
}

export class Unregulated extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      dataCS: CoordinateSystem.BG_705,
      error: ''
    }
  }
  getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={this.state.dataCS}
        onChange={s => this.setState({...this.state, error: '', dataCS: s})}
        className="form-control"
      />
    )
  }
  getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (this.state.file) {
      adds[this.state.file.name] = this.state.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            this.setState({...this.state, file: file, error: ''})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }
  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!this.state.file}
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.file!.file!, this.state.file!.name)
          formData.append('DataCS', this.state.dataCS)
          this.setState({...this.state, loading: true}, () => {
            Axios.post(config.getConfig().urls.importUnregulated, formData, {
              headers: {'Content-Type': `multipart/form-data;`}
            })
              .then(r => {
                this.setState({...this.state, afterSuccess: true, error: '', loading: false})
              })
              .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                  this.setState({...this.state, error: error.response.data})
                } else {
                  this.setState({...this.state, error: 'Възникна грешка ' + error.message, loading: false})
                }
              })
          })
        }}
      >
        Импорт (данните се записват без потвърждение в базата)
      </button>
    )
  }
  afterSuccess() {
    return (
      <div>
        <div className="success-div">Успешен импорт</div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined})
          }}
        >
          Нов импорт
        </button>
      </div>
    )
  }

  onerror() {
    return (
      <div className="error-div">
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined, error: ''})
          }}
        >
          Нов импорт
        </button>
        {this.state.error}
      </div>
    )
  }
  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {this.state.afterSuccess ? (
          this.afterSuccess()
        ) : this.state.error ? (
          this.onerror()
        ) : (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>
            <div style={{textAlign: 'center'}}>
              Импорт на допълнителна улична регулация. Очаква се DXF файл с линии.
              <br></br>
              Линиите могат да бъдат или в слой RP_REG или RP_REG_KR.
              <br></br>
              RP_REG се представя с плътна червена линия.
              <br></br>
              RP_REG_KR се представя с пунктир.
            </div>
            {this.getContainer(this.getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
            {this.getContainer(this.getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
            {this.getExecuteButton()}
          </div>
        )}
      </div>
    )
  }
}
